import { createFailure, createRequest, createSuccess } from 'ducks/helpers';
import constants from './constants';

export const settingsRequest = createRequest(constants.settings);
export const settingsSuccess = createSuccess(constants.settings);
export const settingsFailure = createFailure(constants.settings);

export const updateSettingsRequest = createRequest(constants.updateSettings);
export const updateSettingsSuccess = createSuccess(constants.updateSettings);
export const updateSettingsFailure = createFailure(constants.updateSettings);

export const requestTeamsSettings = settingsRequest;
export const updateTeamsSettings = updateSettingsRequest;
